import { render, staticRenderFns } from "./QueryEditor.vue?vue&type=template&id=4a176b05&"
import script from "./QueryEditor.vue?vue&type=script&lang=js&"
export * from "./QueryEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/workspace/is_minesweeper-flags-client_main/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VBtnToggle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
installComponents(component, {VBtn,VBtnToggle,VChip})
